import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getCaseTypeListData } from './mockData'
import type { ICaseType } from '@/types/case/models'

// get

interface GetCaseTypesResponse {
  data: ICaseType[]
}

async function getCaseTypes(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetCaseTypesResponse = {
    data: await getCaseTypeListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postCaseType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCaseTypeListData)
}

const patchCaseType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCaseTypeListData)
}

const deleteCaseType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCaseTypeListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/casetypes',
    handler: getCaseTypes,
  },
  {
    method: 'post',
    path: '/api/casetypes',
    handler: postCaseType,
  },
  {
    method: 'patch',
    path: '/api/casetypes/:id',
    handler: patchCaseType,
  },
  {
    method: 'delete',
    path: '/api/casetypes/:id',
    handler: deleteCaseType,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
